import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const marques = [
  {
    titleKey: 'marque_bp_title',
    descKey: 'marque_bp_desc',
    img: 'https://readdy.ai/api/search-image?query=Quebec residential house with new asphalt shingle roof in warm brown color, beautiful suburban Lévis neighborhood, sunny day, professional real estate photography, clean modern architecture, no text visible, landscape composition',
    alt: 'Toiture bardeau BP Canada maison Lévis',
  },
  {
    titleKey: 'marque_iko_title',
    descKey: 'marque_iko_desc',
    img: 'https://readdy.ai/api/search-image?query=Quebec residential house with new asphalt shingle roof in slate grey color, Cambridge style architectural shingles, suburban neighborhood, bright sunny day, professional real estate photography, no text visible, landscape composition',
    alt: 'Toiture bardeau IKO Cambridge gris ardoise Lévis',
  },
  {
    titleKey: 'marque_gaf_title',
    descKey: 'marque_gaf_desc',
    img: 'https://readdy.ai/api/search-image?query=Luxury Quebec house with premium GAF Timberline HDZ asphalt shingle roof in dark charcoal color, high-end residential architecture, manicured property, warm golden hour light, professional real estate photography, no text visible',
    alt: 'Toiture bardeau GAF Timberline HDZ premium maison haut de gamme',
  },
];

export default function Marques() {
  const { t } = useTranslation('bardeau');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="marques" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('marques_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-6">
          {marques.map((marque, idx) => (
            <div
              key={idx}
              className={`bg-soft-gray rounded-xl overflow-hidden transition-all duration-700 hover:-translate-y-1 hover:shadow-sm ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              <div className="h-48 md:h-52 overflow-hidden">
                <img
                  src={marque.img}
                  alt={`${marque.alt} — couvreur RBQ à Lévis`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
                  {t(marque.titleKey)}
                </h3>
                <p className="text-slate-primary/60 text-xs md:text-sm leading-relaxed">
                  {t(marque.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}